import React, {useCallback, useEffect, useMemo, useState} from 'react';
import useApi from "../../hooks/useApi";
import IEditorOptions from "../../models/IEditorOptions";
import {SelectBox} from "devextreme-react/select-box";
import IUsager from "../../models/IUsager";
import Guid from "../../models/Guid";

function useUsager() {
    const {data: usager, getData: getUsager} = useApi<IUsager[]>('usager');
    const [currentSelectedItem, setCurrentSelectedItem] = useState<IUsager>();

    useEffect(() => {
        getUsager();
    }, [])

    const editorOptions = useMemo((): IEditorOptions<IUsager[]> => {
        return {
            searchEnabled: true,
            dataSource: usager,
            displayExpr: ((item: IUsager) => item && `${item.prenom} ${item.nom}`),
            displayValue: "idUsager",
            valueExpr: "idUsager",
        }
    }, [usager])

    const UsagerSelectBox = useCallback((params: any) => {
        const {dataField, component, column, data} = params;
        const formOptions = component.option();
        const value = dataField ? formOptions.formData[dataField] : data[column.dataField];

        const onValueChanged = (args: any) => {
            component.updateData(dataField, args.value);
        }

        const onSelectionChanged = (e: any) => {
            setCurrentSelectedItem(e.selectedItem);
        }

        return (
            <SelectBox readOnly={formOptions.readOnly} onSelectionChanged={onSelectionChanged} dataSource={editorOptions.dataSource} displayExpr={editorOptions.displayExpr} displayValue={editorOptions.displayValue} valueExpr={editorOptions.valueExpr} value={value} onValueChanged={onValueChanged}/>
        )
    }, [editorOptions, currentSelectedItem]);

    const getUsagerNamebyId = (idUsager: Guid): string => {
        const user = usager?.find(u => u.idUsager?.equals(idUsager));
        return `${user?.prenom || ''} ${user?.nom || ''}`;
    }

    return {
        usagerEditorOptions: editorOptions,
        usager,
        currentUsager: currentSelectedItem,
        refreshData: () => getUsager(),
        UsagerSelectBox,
        getUsagerNamebyId
    }
}

export default useUsager;